<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <section class="bread_crumb">
            <div class="container">
                <ul>
                    <li>
                        <router-link class="" v-bind:to="'/'">{{ $t("Header.Home") }}</router-link>
                    </li>
                    <li>
                        <router-link v-bind:to="'/contact-us/'">{{ $t("Contact us") }}</router-link>
                    </li>
                    <li>
                        Thankyou
                    </li>
                </ul>
            </div>
        </section>
        <section class="inner_wrap">
            <div class="container">   
                <div class="contact_page">         
                    <div class="row">
                        <div class="col-md-12 thanks_text">
                        <h2>Thank You!</h2>
                        <p>For contacting us, we will get back to you as soon as possible.</p>
                        </div>                    
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import HeaderMenu from '../HeaderMenu'
export default {
    name: 'Thankyou',
    components:{
        HeaderMenu:HeaderMenu
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Thankyou.vue